import { Component, Input } from '@angular/core';
import { OrderDetailModel } from '@cv-invision/cv.invision-intelligence.ux';
import { HistoricalOrderDialogComponent } from '../dialogs/historical-order-dialog/historical-order-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	selector: 'cv-historical-order-details-button',
	templateUrl: './historical-order-detail.component.html',
	host: {
		class: 'd-inline-flex align-items-center'
	}
})
export class HistoricalOrderDetailsButtonComponent {
	@Input() orderDetail: OrderDetailModel;

	constructor(private dialogService: DialogService) {}

	/**
	 * Triggers dialog when a pipeline element is clicked
	 * @param indicator
	 */
	openDialog() {
		this.dialogService.open(HistoricalOrderDialogComponent, {
			header: 'Historical Order Details',
			width: '1400px',
			height: '800px',
			data: {
				orderDetail: this.orderDetail
			}
		});
	}
}
